import { useRefreshCandidate } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdPut } from "#candidate/services/api"
import { DialogMaster } from "#core/components/dialog/Dialog"
import InputAutocomplete from "#core/inputs/autocomplete/InputAutocomplete"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { vacancyGet } from "#vacancy/services/api"
import { Box, TextField, Typography } from "@mui/material"
import { Fragment, useCallback, useMemo, useState } from "react"

export default function CandidateActionMove({ open, setOpen }) {
	const [reason, setReason] = useState(null)
	const [vacante, setVacante] = useState(null)
	const [disabled, setDisabled] = useState(false)
	const { candidateId, candidate } = useCandidateRedux()
	const { refresh } = useRefreshCandidate()

	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(candidateIdPut, { success, end })
	const params = useMemo(() => ({ list: true, activated: true }), [])
	const { data } = useApi(vacancyGet, { autoFetch: open, params })

	const handleSubmit = useCallback(() => {
		setDisabled(true)
		fetch(candidateId, {
			vacante: vacante.id,
			reason,
		})
	}, [candidateId, fetch, reason, vacante?.id])

	const vacantes = useMemo(
		() =>
			data?.data
				.filter((item) => item.id !== candidate.vacante)
				.map((item) => ({
					id: item.id,
					label: `${item.perfil_puesto_name} - ${item.sucursal_name} - ${item.tipo_vacante}`,
				})) || [],
		[candidate.vacante, data?.data]
	)

	return (
		<Fragment>
			<DialogMaster
				{...{
					title: "Mover candidato a otra vacante",
					open,
					setOpen,
					handleSubmit,
					disabled,
					maxWidth: "md",
				}}
			>
				<Box display="flex" flexDirection="column" gap={3}>
					<Box>
						<Typography variant="body1" gutterBottom>
							<strong>Candidato:</strong> {candidate.candidate_name}
						</Typography>
					</Box>

					<Box
						sx={{
							p: 2,
							borderRadius: 1,
						}}
					>
						<Typography variant="body1" color="text.secondary" gutterBottom>
							Esta acción moverá al candidato en su estado actual a la nueva vacante
							seleccionada.
						</Typography>
						<Typography variant="body1" color="warning.main" fontWeight={500}>
							⚠️ Si el candidato era un candidato final, su estado regresará a
							"Entrevistado por el jefe".
						</Typography>
					</Box>

					<Box>
						<Typography variant="subtitle2" gutterBottom>
							Vacante destino ({vacantes.length || 0} disponibles)
						</Typography>
						<InputAutocomplete
							options={vacantes}
							optionsLabel="label"
							label="Seleccione la vacante"
							setValue={setVacante}
							value={vacante}
						/>
					</Box>

					<Box>
						<Typography variant="subtitle2" gutterBottom>
							Motivo del cambio
						</Typography>
						<TextField
							value={reason}
							fullWidth
							multiline
							rows={3}
							placeholder="Describa el motivo del cambio de vacante..."
							onChange={(e) => setReason(e.target.value)}
						/>
					</Box>
				</Box>
			</DialogMaster>
		</Fragment>
	)
}
